var collapsible_list_pair_rtlignore_default = {
  "container": "Y5r6V",
  "title": "-Rka1",
  "viewerContainer": "zxbtL",
  "titleContainer": "CqMRp",
  "content": "_9a-ai",
  "expandIcon": "VlNqe",
  "dndIcon": "S8MlA",
  "RTL": "eD5eB",
  "LTR": "ZFZQr",
  "itemContainer": "mXXVl",
  "itemContainerViewer": "k1MN0",
  "mouseDown": "P0uUA",
  "innerEditor": "h15DR",
  "item": "a4hsR",
  "floatingAddPluginMenuWrapper": "ShOAa"
};
export {
  collapsible_list_pair_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-pair.rtlignore-scss.js.map
